/**
 * @fileoverview added by tsickle
 * Generated from: product-type/product-type.enum.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const ProductTypeEnum = {
    UNIT_TRUST: "ut",
    DPMS: "dpms",
    BOND: "bond",
    INSURANCE: "insurance",
    STOCK: "stock",
    ETF: "etf",
};

/**
 * @fileoverview added by tsickle
 * Generated from: product-type/product-type.type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: product-type/public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: config/antd-config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// Refer to https://ng.ant.design/docs/global-config/en
/** @type {?} */
const antdConfig = {
    grid: {
        nzGutter: 16
    }
};

/**
 * @fileoverview added by tsickle
 * Generated from: config/public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-util.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ProductTypeEnum, antdConfig };


//# sourceMappingURL=b2c-ui-util.js.map